// extracted by mini-css-extract-plugin
module.exports = {"label":"_24h-e"};